import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
// Verification and password reset emails, and the pages their links open, in French
auth.languageCode = "fr";
const db = getFirestore(app);
const storage = getStorage(app);

// 👇 Local emulators: `npm run dev` sets REACT_APP_USE_EMULATORS=true.
// Ports must match the "emulators" section of firebase.json.
if (process.env.REACT_APP_USE_EMULATORS === "true") {
  const host = "127.0.0.1";
  connectAuthEmulator(auth, `http://${host}:9180`);
  connectFirestoreEmulator(db, host, 8180);
  connectStorageEmulator(storage, host, 9190);
  console.info("🔧 Firebase emulators: auth :9180, firestore :8180, storage :9190");
}

export { auth, db, storage };
